// extracted by mini-css-extract-plugin
var _1 = "b7CvfmPtV_moF3Rrz1Ik";
export { _1 as "directionCol" }
